
import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { errorHandler } from "utils/Api";
import form from 'formConfigs/userProfile';
import DynamicForm from "components/DynamicForm";
import AddIcon from '@mui/icons-material/Add';
import { showAlert } from "utils/Alert";
import { getUserData, updateUserProperties } from "utils/Session";
import { updateInputProperties } from "components/DynamicForm/utils";
import AddDeliveryAddressOffCanvas from "components/OffCanvas/AddDeliveryAddressOffCanvas";
import { getPOBoxByUser, savePoBox } from "api/POBoxApi";
import ConfirmModal from "components/ConfirmModal";
import { deleteAddress } from "api/AddressApi";
import { getAddressOptions } from "utils/Utils";

const UserProfileForm = props => {
    const { formId, className, onSave } = props;
    const [poBox, setPoBox] = useState();
    const [userProfileData, setUserProfileData] = useState({});
    const [userAddresses, setUserAddresses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isConfirmOpen, setConfirmOpen] = useState(false);
    const [toDeleteAddress, setToDeleteAddress] = useState({});
    const [toEditAddress, setToEditAddress] = useState({});

    useEffect(() => {
        setIsLoading(true);
        setInitialData();
    }, []);

    const setInitialData = async () => {
        const userData = await getUserData();
        if (userData.id) {
            setUserProfileData(userData.attributes);
            getPOBoxByUser(userData).then((r) => {
                setPoBox(r);
                setUserAddresses(r.addresses?.items || []);
            }).catch((e) => {
                errorHandler(e, "Fetch PO Box Data")
            }).finally((r) => setIsLoading(false));
        }
    }

    const saveUserProfileData = (formData) => {
        setIsLoading(true);

        delete formData["addresses"];
        updateUserProperties(formData)
        .then(async(r)=>{
            const poBoxData = {
                ...poBox,
                name: formData.name,
                email: formData.email,
                phone: formData["custom:tel_mobile"]
            }
            await savePoBox(poBoxData);
            return r;
        })
        .then((r) => {
            if (r) {
                showAlert("success", "La informacion de su perfil fue guardada exitosamente");
                if (onSave) {
                    onSave(r);
                }
            } else {
                showAlert("danger", "No fue posible guardar la informacion de su perfil");
            }
        }).catch(e => {
            showAlert("danger", "No fue posible guardar la informacion de su perfil")
            errorHandler(e, "Actualizar informacion de Perfil");
        }).finally(e => setIsLoading(false));
    }

    const onAddressAdded = (addressData) => {
        const newAddressList = [
            ...userAddresses,
            addressData
        ]
        setUserAddresses(newAddressList);
    }

    const onAddressModifed = (addressData) => {
        let newAddressList = userAddresses.filter(a => a.id !== addressData.id);

        newAddressList = [
            ...newAddressList,
            addressData
        ]
        setUserAddresses(newAddressList);
    }

    const getProfileFormConfig = () => {
        const properties = {
            addBtn: <AddDeliveryAddressOffCanvas
                className="float-end"
                btnColor="success"
                onSave={onAddressAdded}
                poBox={poBox}>
                <AddIcon /> 
            </AddDeliveryAddressOffCanvas>,
            editBtnAction: (address) => {
                setToEditAddress(address);
            },
            deleteBtnAction: (address) => {
                setToDeleteAddress(address);
                setConfirmOpen(true);
            }
        }
        let formConfig = updateInputProperties(form, "addresses", properties);

        const addressOptions = getAddressOptions(userAddresses);
        const newDeliveryOption = { options: addressOptions };
        formConfig = updateInputProperties(formConfig, "custom:delivery_type", newDeliveryOption);
        return formConfig;
    }

    const getProfileData = () => {
        return {
            ...userProfileData,
            addresses: JSON.stringify(userAddresses)
        }
    }

    const onDeleteconfirm = () => {
        setIsLoading(true);
        deleteAddress(toDeleteAddress)
            .then(async (r) => {
                showAlert("success", `La direccion #${toDeleteAddress.name} fue eliminado correctamente`);
                const newAddressList = userAddresses.filter(a => a.id !== toDeleteAddress.id);
                setUserAddresses(newAddressList);
            }).catch(e => {
                errorHandler(e);
                showAlert("danger", `No fue posible eliminar la direccion #${toDeleteAddress.name}`);
            })
            .finally(() => {
                toogleModal();
                setToDeleteAddress({});
                setIsLoading(false);
            });

    }
    const toogleModal = (e) => {
        setConfirmOpen(!isConfirmOpen);
        if (isConfirmOpen) {
            setToDeleteAddress({});
        }
    }

    const onDeliveryOffCanvasClose = () => {
        setToEditAddress({});
    }

    const updateProfileData = (fieldName, value) => {
        const newProfileData = {
            ...userProfileData,
            [fieldName]: value
        }
        setUserProfileData(newProfileData);
    }

    return (
        <Container className={className}>
            <AddDeliveryAddressOffCanvas
                className="float-end"
                btnColor="none"
                onSave={onAddressModifed}
                poBox={poBox}
                onClose={onDeliveryOffCanvasClose}
                address={toEditAddress}>
            </AddDeliveryAddressOffCanvas>
            <ConfirmModal
                toggle={toogleModal}
                isOpen={isConfirmOpen}
                title="Eliminar direccion"
                onConfirm={onDeleteconfirm}
                primaryBtn="Eliminar"
            >
                Esta seguro que desea eliminar este direccion?
            </ConfirmModal>
            <DynamicForm
                id={formId}
                externalFormState={getProfileData()}
                onInputChange={updateProfileData}
                formConfig={getProfileFormConfig()}
                onSubmit={saveUserProfileData}
                isLoading={isLoading}>
            </DynamicForm>
        </Container>
    );
}
export default UserProfileForm;
